<pds-module-header title="Restrição Vendedores" ctaLabel="Nova restrição" ctaPath="/operacoes/restricao-vendedores/novo">
  <pds-new-breadcrumb [items]="breadcrumbItems"></pds-new-breadcrumb>

  <ng-container *ngIf="state.loading">
    <p>Carregando restrições...</p>
  </ng-container>

  <ng-container *ngIf="state.data?.length">
    <pds-table>
      <table>
        <thead>
          <tr>
            <th>Canais</th>
            <th>Vendedores</th>
            <th>Ativo</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of state.data">
            <td>
              <span pdsChip *ngFor="let channel of item.salesChannels" style="margin-left: var(--space-2)">{{ channel.name }}</span>
            </td>
            <td>
              <span pdsChip *ngFor="let seller of item.sellers" style="margin-left: var(--space-2)">{{ seller.name }}</span>
            </td>
            <td pdsColActions>
              @if (item.enabled) {
              <strong><span pdsChip="primary">Ativo</span></strong>
              } @else {
              <strong><span pdsChip>Inativo</span></strong>
              }
            </td>
            <td pdsColActions>
              <button pdsButton="icon" modifier="outlined" title="Detalhes" (click)="onClickDetails(item)">
                <span class="icon">visibility</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </pds-table>
  </ng-container>

  <ng-container *ngIf="state.data && !state.data.length">
    <strong>Nenhuma restrição encontrada.</strong>
  </ng-container>

  <ng-container *ngIf="state.failure">
    <pds-alert type="error" title="Erro ao carregar">Tente novamente em instantes.</pds-alert>
  </ng-container>
</pds-module-header>
